import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { db } from '../firebaseConfig';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { useAuth } from '../context/AuthContext';
import { IoArrowBack, IoCarSportOutline, IoBarcodeOutline } from 'react-icons/io5';
import KondoSidebar from '../components/Shared/KondoSidebar';
import KondoBrandHeader from '../components/Shared/KondoBrandHeader';
import KondoBottomNav from '../components/Shared/KondoBottomNav';
import './AdminEditarVehiculoScreen.css'; // --- New CSS ---

function AdminEditarVehiculoScreen() {
  const navigate = useNavigate();
  const { vehiculoId } = useParams();
  const { userData } = useAuth(); // Datos del Admin

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Estados del formulario
  const [marca, setMarca] = useState('');
  const [modelo, setModelo] = useState('');
  const [tipo, setTipo] = useState('auto'); // Nuevo campo Tipo
  const [placas, setPlacas] = useState('');
  const [color, setColor] = useState('');
  const [anio, setAnio] = useState('');

  // ¡Campos de Admin!
  const [tagId, setTagId] = useState('');
  const [estatus, setEstatus] = useState('pendiente');

  // 1. Cargar los datos del vehículo
  useEffect(() => {
    if (!vehiculoId || !userData) return;

    const fetchVehiculo = async () => {
      setLoading(true);
      try {
        const docRef = doc(db, "vehiculos", vehiculoId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();

          if (data.condominioId !== userData.condominioId) {
            setError("No tienes permiso para editar este vehículo.");
            setLoading(true);
            return;
          }

          setMarca(data.marca || '');
          setModelo(data.modelo || '');
          setTipo(data.tipo || 'auto'); // Cargar tipo
          setPlacas(data.placas || '');
          setColor(data.color || '');
          setAnio(data.anio || '');
          setTagId(data.tagId || '');
          setEstatus(data.estatus || 'pendiente');

        } else {
          setError("No se encontró el vehículo.");
        }
      } catch (e) {
        setError("Error al cargar datos.");
        console.error(e);
      }
      setLoading(false);
    };

    fetchVehiculo();
  }, [vehiculoId, userData]);

  // 2. Guardar los cambios (Admin)
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (estatus === 'activo' && !tagId) {
      setError("Debes asignar un 'TAG ID' para activar el vehículo.");
      return;
    }
    const tagFinal = (estatus === 'pendiente') ? '' : tagId;

    setLoading(true);
    setError('');

    try {
      const docRef = doc(db, "vehiculos", vehiculoId);

      await updateDoc(docRef, {
        marca: marca,
        modelo: modelo,
        tipo: tipo, // Guardar tipo
        placas: placas.toUpperCase(),
        color: color,
        anio: anio,
        tagId: tagFinal,
        estatus: estatus
      });

      alert("¡Vehículo actualizado con éxito!");
      navigate('/gestion-vehiculos');

    } catch (e) {
      console.error("Error al actualizar vehículo: ", e);
      setError("Error al guardar los cambios.");
      setLoading(false);
    }
  };

  return (
    <div className="ks-page">
      <KondoSidebar activeRoute="/gestion-vehiculos" />
      
      <main className="ks-main">
        <div className="ks-header-sticky-wrapper">
          <KondoBrandHeader showBack={false} />
        </div>

        <div className="ks-scroll-area">
          <div className="admin-vehiculo-page">
            <div className="admin-vehiculo-wrapper">
              
              {/* --- STANDARD PREMIUM HERO BANNER --- */}
              <div className="app-header-sticky" style={{ padding: '0 0 20px 0' }}>
                <div className="kondo-banner-standard" style={{ background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)', margin: 0, boxShadow: '0 10px 25px rgba(29, 78, 216, 0.25)' }}>
                  <div className="banner-standard-content">
                    <button type="button" onClick={() => navigate('/gestion-vehiculos')} className="banner-back-btn-standard">
                      <IoArrowBack size={24} />
                    </button>
                    <div className="banner-standard-text">
                      <h2>Validar Vehículo</h2>
                      <p>Asigna TAGs, revisa placas y aprueba accesos de residentes.</p>
                    </div>
                  </div>
                  <IoCarSportOutline className="banner-standard-icon-decor" />
                </div>
              </div>

              {error && <div className="error-msg" style={{ marginBottom: '20px' }}>{error}</div>}

              <form onSubmit={handleSubmit} className="admin-form-card-premium">
                
                <div className="admin-form-grid-premium">
                  
                  {/* Sección: Datos del Vehículo */}
                  <div className="admin-section-card-premium">
                    <div className="admin-section-title-premium">
                      <div className="section-icon-premium"><IoCarSportOutline size={20} /></div>
                      <span>Datos del Vehículo</span>
                    </div>

                    <div className="premium-field-group">
                      <label className="premium-field-label">Placas (Matrícula)</label>
                      <input
                        type="text"
                        value={placas}
                        onChange={(e) => setPlacas(e.target.value)}
                        className="premium-field-input placas-input-premium"
                        style={{ textTransform: 'uppercase', fontWeight: '800', letterSpacing: '1px' }}
                        required
                      />
                    </div>

                    <div className="premium-field-group">
                      <label className="premium-field-label">Tipo de Vehículo</label>
                      <select
                        value={tipo}
                        onChange={(e) => setTipo(e.target.value)}
                        className="premium-field-select"
                      >
                        <option value="auto">🚘 Automóvil / Sedán</option>
                        <option value="suv">🚙 SUV / Camioneta</option>
                        <option value="moto">🏍️ Motocicleta</option>
                        <option value="camion">Van / Furgoneta</option>
                      </select>
                    </div>

                    <div className="premium-field-group">
                      <label className="premium-field-label">Marca</label>
                      <input 
                        type="text" 
                        value={marca} 
                        onChange={(e) => setMarca(e.target.value)} 
                        className="premium-field-input" 
                        placeholder="Ej. Toyota, Mazda"
                        required 
                      />
                    </div>

                    <div className="premium-field-group">
                      <label className="premium-field-label">Modelo</label>
                      <input 
                        type="text" 
                        value={modelo} 
                        onChange={(e) => setModelo(e.target.value)} 
                        className="premium-field-input" 
                        placeholder="Ej. Corolla, CX-5"
                      />
                    </div>

                    <div className="form-grid-two-cols">
                      <div className="premium-field-group">
                        <label className="premium-field-label">Color</label>
                        <input 
                          type="text" 
                          value={color} 
                          onChange={(e) => setColor(e.target.value)} 
                          className="premium-field-input" 
                          placeholder="Ej. Blanco"
                        />
                      </div>
                      <div className="premium-field-group">
                        <label className="premium-field-label">Año</label>
                        <input 
                          type="number" 
                          value={anio} 
                          onChange={(e) => setAnio(e.target.value)} 
                          className="premium-field-input" 
                          placeholder="Ej. 2024"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Sección: Control de Acceso (Validación y TAG) */}
                  <div className="admin-section-card-premium">
                    <div className="admin-section-title-premium">
                      <div className="section-icon-premium" style={{ color: '#10b981', background: '#d1fae5' }}><IoBarcodeOutline size={20} /></div>
                      <span>Control de Acceso</span>
                    </div>

                    <div className="premium-field-group">
                      <label className="premium-field-label">Estatus de Validación</label>
                      <select
                        value={estatus}
                        onChange={(e) => setEstatus(e.target.value)}
                        className={`premium-field-select status-select-premium ${estatus}`}
                      >
                        <option value="pendiente">⏳ Pendiente de Validación</option>
                        <option value="activo">✅ Activo (Permitir Acceso)</option>
                        <option value="inactivo">❌ Inactivo (Acceso Denegado)</option>
                      </select>
                      <p className="field-helper-text">
                        Solo los vehículos con estatus <strong>Activo</strong> podrán registrar ingresos automáticos.
                      </p>
                    </div>

                    <div className="premium-field-group">
                      <label className="premium-field-label">TAG ID (Sticker / RFID Chip)</label>
                      <input
                        type="text"
                        value={tagId}
                        onChange={(e) => setTagId(e.target.value)}
                        className="premium-field-input tag-input-premium"
                        placeholder="Escanea o escribe el ID del tag"
                      />
                      {estatus === 'activo' && !tagId ? (
                        <p className="field-error-text">
                          * Se requiere asignar un TAG ID para activar el vehículo.
                        </p>
                      ) : (
                        <p className="field-helper-text">
                          Vincula el tag RFID del parabrisas para la apertura automática de plumas.
                        </p>
                      )}
                    </div>
                  </div>

                </div>

                <div className="premium-form-actions">
                  <button type="button" onClick={() => navigate('/gestion-vehiculos')} className="premium-btn-secondary">
                    Cancelar
                  </button>
                  <button type="submit" className="premium-btn-primary" disabled={loading}>
                    {loading ? 'Guardando...' : 'Guardar y Validar'}
                  </button>
                </div>

              </form>
            </div>
          </div>
        </div>
        <KondoBottomNav activeRoute="/gestion-vehiculos" />
      </main>
    </div>
  );
}

export default AdminEditarVehiculoScreen;